import { Todo } from "./todo.model";

export class todoCategory {
  id: string;
  name : string;
  sections: Section[];
  constructor(data?: Partial<todoCategory>) {
    this.id = data?.id || "";
    this.name  = data?.name || "";
    this.sections = data?.sections || [];
  }
}

export class Section {
  id: string;
  name : string;
  sequence : number;
  todos: Todo[] | null;
  constructor(data?: Partial<Section> | null) {
    this.id = data?.id || "";
    this.name  = data?.name || "";
    this.sequence = data?.sequence || 0;
    this.todos = data?.todos || [];
  }
}

